import { ProfileMenu } from '@shared/components/profile-menu';
import { SidebarTrigger } from '@src/design-system/sidebar';
import UpgradeMenu from '@shared/components/upgrade-menu';
import { BoxAdd, Microscope } from 'iconsax-react';
import { Button } from '../button';
import { useState } from 'react';
import { AppMainReminder } from '@shared/components/reusables/reminder-bar/app-main-reminder';
import { NotificationMenu } from '@src/features/notifications';

export function AppHeader() {
  const [showAlert, setShowAlert] = useState(false);

  return (
    <>
      <header className='flex bg-white border-b border-primary-200 py-3 shrink-0 items-center gap-2 transition-[width,height] ease-linear'>
        <div className='flex w-full justify-between items-center gap-2 px-4'>
          <SidebarTrigger className='-ml-1' />
          <div className='flex items-center gap-2'>
            <UpgradeMenu />
            <NotificationMenu />
            <ProfileMenu />
          </div>
        </div>
      </header>
      {showAlert && (
        <div className='bg-secondary-1000 text-white flex items-center justify-center px-6 py-2'>
          <p className='font-medium text-lg flex gap-3 ms-auto items-center'>
            <Microscope
              size='24'
              color='#fff'
            />
            [Applications] limit reached, add more via
            <Button
              variant='ghost'
              className='bg-transparent border'
              size='sm'
              style={{ color: '#F3FF07', borderColor: '#F3FF07' }}
            >
              <BoxAdd />
              Add on
            </Button>
          </p>
          <p
            className='ms-auto cursor-pointer'
            onClick={() => setShowAlert(false)}
          >
            X
          </p>
        </div>
      )}
      <AppMainReminder />
    </>
  );
}
